<template>
  <div class="container" style="height: 100%">
    <ValidationObserver ref="observer" v-if="!loading">
      <v-row>

        <v-col cols="12" sm="3" md="3" lg="3" class="campo">
          <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
            <autocomplete-cadu
              title="Tipo de Cooperativa"
              v-model="tipoCooperativa.nome"
              placeholder=""
              :errorMessage="errors[0]"
              :disabled="isAdminBrasil"
              :items="listaTiposCooperativa.map((el) => el.nome)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              @input="(input) => comboIndex(input, 'coop')"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="3" md="3" lg="3" class="campo" v-if="mostrarCampoTipoFederacao">
          <ValidationProvider mode="eager" :rules="federacaoComputed ? '' : 'required'" v-slot:default="{ errors }">
            <autocomplete-cadu
              title="Tipo de Federação"
              v-model="tipoFederacao.nome"
              placeholder=""
              :errorMessage="errors[0]"
              :items="listaFederacao().map((el) => el.nome)"
              :disabled="isAdminBrasil && federacaoComputed"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              @input="(input) => comboIndex(input, 'fede')"
            />
          </ValidationProvider>
        </v-col>


        <v-col cols="12" sm="3" md="3" lg="3" class="campo">
          <ValidationProvider mode="eager" :rules="'required'" v-slot:default="{ errors }">
            <autocomplete-cadu
              title="Tipo de Atuação"
              v-model="tipoAtuacao.nome"
              placeholder=""
              :disabled="isAdminBrasil"
              :errorMessage="errors[0]"
              :items="listaTiposAtuacao.map((el) => el.nome)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              @input="(input) => comboIndex(input, 'atua')"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="3" md="3" lg="3" class="campo">
          <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              title="Grau da Cooperativa"
              v-model="grauCooperativa.nome"
              placeholder=""
              :disabled="isAdminBrasil"
              :items="listaGrauCooperativa.map((el) => el.nome)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              @input="(input) => comboIndex(input, 'grau')"
            />
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row>

        <v-col cols="12" sm="3" md="3" lg="3" class="campo">
          <ValidationProvider mode="eager" rules="min:6" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Registro ANS"
              :disabled="isAdminBrasil"
              placeholder=""
              v-mask="'######'"
              v-model="registroANS"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>

        <!-- Data Reg. Definitivo -->
        <v-col cols="12" sm="5" md="5" lg="3" class="campo">
          <ValidationProvider rules="dateValidatorForPass">
            <datepicker-cadu
              rules="dateValidatorForPass"
              :menuOpen="menuOpen"
              inputTitle="Data Reg. Definitivo"
              placeholder=""
              validateProviderRules="dateMaiorHoje"
              :inputValue="dataRegistroDefinitivo"
              @value="(value) => (dataRegistroDefinitivo = value)"
              typeCalendar="date"
              :disabled="isAdminBrasil"
              width="280"
            ></datepicker-cadu>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="4" md="4" lg="3" class="campo" v-if="showCancelamento">
          <datepicker-cadu
            rules="dateValidatorForPass"
            :menuOpen="menuOpen"
            inputTitle="Data Cancelamento"
            ref="cancelamento"
            placeholder=""
            :inputValue="dataCancelamento"
            :validateProviderRules="rulesCancelamento"
            @value="(value) => dataCancelamentoValido(value)"
            typeCalendar="date"
            :disabled="isAdminBrasil"
            width="280"
          ></datepicker-cadu>
        </v-col>

        <v-col cols="12" sm="4" md="4" lg="3"  class="campo" v-if="showCancelamento">
          <ValidationProvider mode="eager" :rules="motivoDisabled ? '' : 'max:500'" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Motivo Cancelamento"
              :disabled="motivoDisabled ? '' : isAdminBrasil"
              placeholder=""
              :max="'500'"
              onlyText
              v-model="motivoCancelamento"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6" class="campo" v-if="(isAdmBrasil) || (isNotAdmin && unimedVinculada.textoExibicao)">
          <ValidationProvider mode="eager" :rules="operadoraDisabled ? '' : 'max:100'" v-slot:default="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              title="Unimed Operadora Vinculada"
              :disabled="isAdminBrasil"
              placeholder=""
              v-model="unimedVinculada.textoExibicao"
              onlyAlphaNum
              :items="listaUnimedVinculada.map((el) => el.textoExibicao)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              @input="(input) => comboIndex(input, 'vincu')"
            />
          </ValidationProvider>
        </v-col>

        <!-- Data em que virou Prestadora -->
        <v-col cols="12" sm="6" md="6" lg="6" class="campo" v-if="!isOperadora">
          <ValidationProvider rules="dateValidatorForPass">
            <datepicker-cadu
              rules="dateValidatorForPass"
              ref="prestadora"
              :menuOpen="menuOpen"
              inputTitle="Data em que deixou de ser Operadora"
              placeholder=""
              validateProviderRules="dateMaiorHoje"
              :inputValue="dataPrestadora"
              @value="(value) => dataPrestadoraValida(value)"
              typeCalendar="date"
              :disabled="isAdminBrasil"
              width="280"
            ></datepicker-cadu>
          </ValidationProvider>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6" class="campo campo-checklist" 
            v-if="isAdmBrasil || (isNotAdmin && unimedSelecionadas.length > 0)" style="margin-top: 2px;">
          <ValidationProvider mode="eager" :rules="operadoraDisabled ? '' : 'max:100'">
            <checkList-cadu
              titulo="Unimed Operadora que Assumiu a Área de Ação"
              itemTextFiltro="textoExibicao"
              :placeholder="showPlaceholderUnimedOperadora"
              :listaFiltro="listaUnimedAreaAcao"
              :tasks="unimedSelecionadas"
              :disabled="isAdminBrasil"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6" class="campo" v-if="isAdmBrasil || (isNotAdmin && podeVerCampoCarteiraBeneficiarios(unimedCarteira.textoExibicao))">
          <ValidationProvider mode="eager" :rules="operadoraDisabled ? '' : 'max:100'" v-slot:default="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              title="Unimed Operadora que Assumiu a Carteira de Beneficiários"
              :disabled="isAdminBrasil"
              v-model="unimedCarteira.textoExibicao"
              onlyAlphaNum
              placeholder=""
              :items="listaUnimedCarteira.map((el) => el.textoExibicao)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              style="white-space: nowrap"
              @input="(input) => comboIndex(input, 'cart')"
            />
          </ValidationProvider>
        </v-col>
       
      </v-row>

    </ValidationObserver>

    <component-loading :value="loading" />

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />

    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import moment from 'moment'

import { mask } from 'vue-the-mask'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { EventBus } from '@/services/EventBus/EventBus'

import TipoCooperativa from '@/services/Dominios/TipoCooperativa'
import TipoAtuacao from '@/services/Dominios/TipoAtuacao'
import GrauCooperativa from '@/services/Dominios/GrauCooperativa'
import Classificacao from '@/services/MinhaUnimed/DadosCadastrais/Classificacao/Classificacao'
import ListarUnimed from '@/services/Unimed/ListarUnimed'

import ValidationMixin from '@/Mixins/ValidationMixin'

import { get, cloneDeep } from 'lodash'

export default {
  directives: { mask },

  mixins: [ValidationMixin],

  components: {
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      listaTiposCooperativa: [],
      listaTiposFederacao: [],
      listaTiposAtuacao: [],
      listaGrauCooperativa: [],
      listaUnimedVinculada: [],
      listaUnimedCarteira: [],
      listaUnimedAreaAcao: [],
      unimedSelecionadas: [],

      tipoCooperativa: {},
      tipoFederacao: {},
      tipoAtuacao: {},
      grauCooperativa: {},
      unimedVinculada: {},
      unimedCarteira: {},
      unimedAreaAcao: {},

      registroANS: '',
      dataRegistroDefinitivo: null,
      dataCancelamento: '',
      motivoCancelamento: '',

      dataPrestadora: '',
      operadoraVinculada: '',

      operadoraCarteiraBeneficiarios: '',
      operadoraAreaAcao: '',

      mostrarCampoTipoFederacao: false,
      desabiltarCampoPrestadora: false,
      desabilitaCamposPrestadoraOperadora: false,
      situacaoUnimed: null,

      teste: false,
      role: '',
      id: '',
      idClassificacao: 0,

      menuOpen: false,

      motivoDisabled: true,
      operadoraDisabled: true,

      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      tokenBearer: localStorage.getItem('tokenBearer'),

      loading: false,
      dadosCadastraisAtiva: false,

      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      cloneClassificacao: {},
      tipoCooperativaIndex: -1,
      showModalCancelar: false,
      rulesCancelamento: 'dateMaiorHoje',
      isOperadora: false,
      isPrestadora: false,
    }
  },

  async beforeMount() {
    const decoded = jwtDecode(this.tokenBearer)

    this.role = decoded.role
    this.id = decoded.isUsuario
    this.loading = true

    await this.getDominios()
    await this.getAllClassificacao()
    await this.getListarUnimed()

    this.verificaAtuacaoUnimed(this.tipoAtuacao.nome)

    this.$emit('complete')
    this.loading = false
  },

  mounted() {
    this.situacaoUnimed = JSON.parse(localStorage.getItem('situacaoUnimed'))
  },

  methods: {
    listaFederacao() {
      return this.listaTiposFederacao[this.tipoCooperativaIndex]
        ? this.listaTiposFederacao[this.tipoCooperativaIndex]
        : []
    },
    isValidDate(value) {
      const validDate = moment(value, 'DD/MM/YYYY', true)

      const dataValidada = validDate.isValid()
      const dateBefore = validDate.isAfter()
      validDate.year()

      return !dateBefore && dataValidada
    },
    podeVerCampoCarteiraBeneficiarios(field) {
      if (field === '0 - NENHUMA UNIMED ASSUMIU A CARTEIRA DE BENEFECIÁRIOS') {
        return false;
      }
      return true;
    },
    dataCancelamentoValido(value) {
      this.dataCancelamento = value

      const isValid = this.isValidDate(value)

      this.$nextTick(async () => {
        if (isValid) {
          this.motivoDisabled = false
          await this.$refs.cancelamento.reset()
        } else {
          this.motivoDisabled = true
          this.motivoCancelamento = ''
        }
      })
    },
    dataPrestadoraValida(value) {
      this.dataPrestadora = value
      const isValid = this.isValidDate(value)

      this.$nextTick(async () => {
        if (isValid) {
          this.operadoraDisabled = false
          await this.$refs.prestadora.reset()
        } else {
          this.operadoraDisabled = true
          this.operadoraVinculada = ''
          await this.$refs.prestadora.setErrors()
        }
      })
    },
    verificaTipoCooperativa(cooperativa) {
      switch (cooperativa) {
        case 'FEDERAÇÃO':
        case 'CONFEDERAÇÃO':
          this.mostrarCampoTipoFederacao = true
          break

        default:
          this.tipoFederacao = {}
          this.mostrarCampoTipoFederacao = false
      }
    },
    verificaAtuacaoUnimed(atuacao) {
      switch (atuacao) {
        case 'INSTITUCIONAL':
          this.isPrestadora = false;
          this.isOperadora = false;
          break;
        case 'OPERADORA':
          this.isOperadora = true;
          this.isPrestadora = false;
          break;
        case 'NÃO SE APLICA':
          this.isOperadora = false;
          this.isPrestadora = false;
          this.situacaoUnimed
            ? (this.desabilitaCamposPrestadoraOperadora = false)
            : (this.desabiltarCampoPrestadora = true)
          break;
        case 'PRESTADORA':
          this.isOperadora = false;
          this.isPrestadora = true;
          this.desabilitaCamposPrestadoraOperadora = true;
          break;
        case 'NÃO OPERADORA':
          this.isOperadora = false;
          this.isPrestadora = true;
          this.desabilitaCamposPrestadoraOperadora = true;
          break;
      }
    },
    comboIndex(input, type) {
      const funcName = (el) => {
        return el.nome === input
      }

      const funcTextoExibicao = (el) => {
        return el.textoExibicao === input
      }

      const index = this.listaTiposCooperativa.findIndex(funcName)
      let objCombo = {}

      if (input !== undefined) {
        switch (type) {
          case 'coop':
            this.tipoCooperativa.nome = input

            input.toLowerCase() === 'não se aplica'
              ? EventBus.$emit('disabledMandatos')
              : EventBus.$emit('activeMandatos')

            this.verificaTipoCooperativa(input)
            this.tipoCooperativa.id = index !== -1 ? this.listaTiposCooperativa[index].id : null
            this.tipoCooperativaIndex = index
            break

          case 'fede':
            this.tipoFederacao.nome = input
            objCombo = this.listaFederacao().find(funcName)
            this.tipoFederacao.id = objCombo ? objCombo.id : null
            break

          case 'atua':
            this.tipoAtuacao.nome = input
            this.verificaAtuacaoUnimed(input)
            objCombo = this.listaTiposAtuacao.find(funcName)
            this.tipoAtuacao.id = objCombo ? objCombo.id : null
            break

          case 'grau':
            this.grauCooperativa.nome = input
            objCombo = this.listaGrauCooperativa.find(funcName)
            this.grauCooperativa.id = objCombo ? objCombo.id : null
            break

          case 'vincu':
            this.unimedVinculada.textoExibicao = input
            objCombo = this.listaUnimedVinculada.find(funcTextoExibicao)
            this.unimedVinculada.id = objCombo ? objCombo.id : null
            break

          case 'cart':
            this.unimedCarteira.textoExibicao = input
            objCombo = this.listaUnimedCarteira.find(funcTextoExibicao)
            this.unimedCarteira.id = objCombo ? objCombo.id : null
            break

          default:
            break
        }
      }
    },
    preparaCloneObject(data) {
      this.cloneClassificacao = data

      const tipoUnimed = get(data.tipoUnimed, 'id', null)
      const tipoFederacao = get(data.tipoFederacao, 'id', null)
      const tipoAtuacao = get(data.tipoAtuacao, 'id', null)
      const grauCooperativa = get(data.grauCooperativa, 'id', null)

      this.cloneClassificacao.tipoUnimed = tipoUnimed ? { id: tipoUnimed } : tipoUnimed
      this.cloneClassificacao.tipoFederacao = tipoFederacao ? { id: tipoFederacao } : tipoFederacao
      this.cloneClassificacao.tipoAtuacao = tipoAtuacao ? { id: tipoAtuacao } : tipoAtuacao
      this.cloneClassificacao.grauCooperativa = grauCooperativa ? { id: grauCooperativa } : grauCooperativa
    },

    async getDominios() {
      await this.getTipoCooperativa()
      await this.getTipoAtuacao()
      await this.getGrauCooperativa()
    },
    async getTipoCooperativa() {
      const tipoCooperativa = new TipoCooperativa(this.tokenBearer, this.$appConfig.config.API)

      await tipoCooperativa
        .getTipoCooperativa()
        .then((res) => {
          res.data.forEach((item) => {
            this.listaTiposCooperativa.push(item)
            this.listaTiposFederacao.push(item.tiposFederacao)
          })
        })
        .catch((err) => {
          console.error(err)

          this.loading = false

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async getTipoAtuacao() {
      const tipoAtuacao = new TipoAtuacao(this.tokenBearer, this.$appConfig.config.API)

      await tipoAtuacao
        .getTipoAtuacao()
        .then((res) => {
          res.data.forEach((item) => this.listaTiposAtuacao.push(item))
        })
        .catch((err) => {
          console.error(err)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async getGrauCooperativa() {
      const grauCooperativa = new GrauCooperativa(this.tokenBearer, this.$appConfig.config.API)

      await grauCooperativa
        .getGrauCooperativa()
        .then((res) => {
          res.data.forEach((item) => this.listaGrauCooperativa.push(item))
        })
        .catch((err) => {
          console.error(err)
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },

    async getAllClassificacao() {
      const classificacao = new Classificacao(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await classificacao
        .getClassificacao()
        .then((res) => {
          const data = res.data

          this.idClassificacao = data.id

          this.tipoCooperativa = data.tipoUnimed || {}
          this.tipoFederacao = data.tipoFederacao || {}
          this.tipoAtuacao = data.tipoAtuacao || {}
          this.grauCooperativa = data.grauCooperativa || {}
          this.unimedVinculada = data.unimedOperadoraVinculada || {}
          this.unimedCarteira = data.unimedOperadoraCarteira || this.getNenhumaUnimed()
          this.unimedAreaAcao = data.unimedOperadoraAreaDeAcao || {}

          this.registroANS = data.registroAns
          this.dataRegistroDefinitivo = data.dataRegistroDefinitivo
          this.dataCancelamento = data.dataCancelamento
          this.motivoCancelamento = data.motivoCancelamento
          this.dataPrestadora = data.dataInicioPrestadora

          this.preparaCloneObject(data)
        })
        .catch((err) => {
          console.error(err)
          this.error = true
          
          console.error(err.response);

          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },

    async cancelarEdicao() {
      this.operadoraDisabled = true
      this.motivoDisabled = true
      this.showModalCancelar = false

      this.loading = true

      await this.getDominios()
      await this.getAllClassificacao()
      await this.getListarUnimed()

      this.loading = false
    },
    async validarMudanca() {
      const tipoFederacao = !(Object.keys(this.tipoFederacao).length === 0) ? this.tipoFederacao : null

      const tipoUnimed = !(Object.keys(this.tipoCooperativa).length === 0) ? this.tipoCooperativa : null

      const tipoAtuacao = !(Object.keys(this.tipoAtuacao).length === 0) ? this.tipoAtuacao : null

      const grauCooperativa = !(Object.keys(this.grauCooperativa).length === 0) ? this.grauCooperativa : null

      const classificacao = {
        id: this.idClassificacao,
        grauCooperativa,
        tipoAtuacao,
        tipoFederacao,
        tipoUnimed,
        dataRegistroDefinitivo: this.dataRegistroDefinitivo,
        dataInicioPrestadora: this.dataPrestadora,
        dataCancelamento: this.dataCancelamento,
        registroAns: this.registroANS,
        motivoCancelamento: this.motivoCancelamento,

        unimedOperadoraAreaDeAcao:
          this.unimedAreaAcao.textoExibicao && this.unimedAreaAcao.id ? this.unimedAreaAcao : null,

        unimedOperadoraCarteira:
          this.unimedCarteira.textoExibicao && this.unimedCarteira.id ? this.unimedCarteira : null,

        unimedOperadoraVinculada:
          this.unimedVinculada.textoExibicao && this.unimedVinculada.id ? this.unimedVinculada : null
      }

      if (this.getDiffInObjects(this.cloneClassificacao, classificacao)) {
        this.showModalCancelar = true
      }
    },
    async validateForm() {
      this.opcaoEditar = JSON.parse(localStorage.getItem('optionEdit'))

      try {
        const response = await this.$refs.observer.validate()

        if (response && this.opcaoEditar) {
          const tipoFederacao = this.tipoFederacao.id ? { id: this.tipoFederacao.id } : null
          const tipoAtuacao = this.tipoAtuacao.id ? { id: this.tipoAtuacao.id } : null
          const tipoUnimed = this.tipoCooperativa.id ? { id: this.tipoCooperativa.id } : null
          const grauCooperativa = this.grauCooperativa.id ? { id: this.grauCooperativa.id } : null
          const dataCancelamento = this.dataCancelamento ? this.dataCancelamento : null
          const motivoCancelamento = this.motivoCancelamento ? this.motivoCancelamento : null

          const classificacaoObj = {
            dataCancelamento,
            motivoCancelamento,
            dataInicioPrestadora: this.dataPrestadora,
            dataRegistroDefinitivo: this.dataRegistroDefinitivo,
            grauCooperativa,
            id: this.idClassificacao,
            registroAns: this.registroANS,
            tipoAtuacao,
            tipoFederacao,
            tipoUnimed,
            unimedOperadoraAreaDeAcao: this.unimedAreaAcao,
            unimedOperadoraCarteira: this.unimedCarteira,
            unimedOperadoraVinculada: this.unimedVinculada
          }

          if (!this.getDiffInObjects(this.cloneClassificacao, classificacaoObj)) {
            this.$emit('complete')
            return true
          }

          const classificacao = new Classificacao(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

          return await classificacao
            .putClassificacao(classificacaoObj)
            .then(() => {
              this.$emit('complete')
              return true
            })
            .catch((err) => {
              this.error = true

              console.error(err.response);

              this.errObj.status = err.response.status
              this.errObj.error = err.response.data.message

              this.$emit('complete')
              return false
            })
        } else if (!this.opcaoEditar) {
          this.$emit('complete')
          return true
        } else {
          this.$emit('complete')
          return false
        }
      } catch (err) {
        this.$emit('complete')
        return false
      }
    },
    async getListarUnimed() {
      const listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)

      await listarUnimed
        .getAll()
        .then(({ data }) => {

          let listaUnimeds = data.filter((u) => u.id !== this.$idUnimed);
          let listaUnimedsClone = cloneDeep(listaUnimeds);
          
          this.listaUnimedVinculada = listaUnimedsClone;
          this.listaUnimedAreaAcao = listaUnimedsClone;
          this.listaUnimedCarteira = listaUnimedsClone;
          this.listaUnimedCarteira.unshift(this.getNenhumaUnimed())
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => {
          this.unimedSelecionadas = this.unimedAreaAcao.map((it) => {
            return { id: it.id, title: it.textoExibicao }
          })
        })
    },

    getNenhumaUnimed() {
      return {
        codigo: null,
        id: null,
        nomeFantasia: 'NENHUMA UNIMED',
        razaoSocial: 'NENHUMA UNIMED',
        textoExibicao: '0 - NENHUMA UNIMED ASSUMIU A CARTEIRA DE BENEFECIÁRIOS'
      }
    }
  },

  watch: {
    unimedSelecionadas(newValue) {
      let unimeds = []

      this.listaUnimedAreaAcao.forEach((unimed) => {
        newValue.forEach((value) => {
          if (value.id == unimed.id) unimeds.push(unimed)
        })
      })

      this.unimedAreaAcao = unimeds
    }
  },
  computed: {
    isAdminBrasil() {
      return this.opcaoEditar === false || this.role !== 'admin_brasil' ? true : false
    },
    isAdmBrasil() {
      return this.role === 'admin_brasil';
    },
    isNotAdmin() {
      return this.role !== 'admin_brasil'
    },
    editarOperadora() {
      return !this.isAdminBrasil ? this.isAdminBrasil : this.operadoraDisabled
    },
    federacaoComputed() {
      if (this.opcaoEditar === true) {
        if (this.tipoCooperativa && this.tipoCooperativa.nome) {
          const nome = this.tipoCooperativa.nome.toLowerCase();
          if (nome === 'federação' || nome === 'confederação') {
            return this.isAdminBrasil;
          }
          return true;
        }
      }
      return true;
    },
    isUnimedDoBrasil() {
      return this.$codigoUnimed === 999 ? true : false
    },
    showCancelamento() {
      return this.tipoAtuacao.id !== 1
    },
    showPlaceholderUnimedOperadora() {
      if (this.opcaoEditar === false) return ''

      if (this.opcaoEditar === true && this.role !== 'admin_brasil') return ''

      return 'Selecione uma ou mais Unimeds'
    }
  }
}
</script>

<style lang="scss" scoped>
.campo-checklist {
  margin-top: -12px;
}
</style>
